import { AI_GATEWAY_API_HOSTNAME } from "config/envConfig";

import LocalStorage from "../../../utils/LocalStorage";
import APIService from "../index";

const aiGatewayAPIInstance = APIService({
  baseURL: AI_GATEWAY_API_HOSTNAME,
});

aiGatewayAPIInstance.interceptors.request.use((config) => {
  config.headers["Authorization"] = LocalStorage.getItem("authToken");

  return config;
});

export default aiGatewayAPIInstance;
